<template>
    <div>
        <search-tabs :type="'tyre_size'" :name="tyre_size.name" :image_path="this.pageDetails.image_base_path+this.pageDetails.image_path" :tyre_size_width="tyre_size_width" :tyre_size_height="tyre_size_height" :tyre_size_diameter="tyre_size_diameter"  ></search-tabs>

        <!-- <div class="breadcrum pb-2 pt-2">
            <div class="container">
                <router-link class="color-black" :to="{ name: 'home' }"> <i class="fas fa-home"></i> </router-link> / 
                {{ $t("Result") }}
            </div>
        </div> -->
        <!-- <div class="container pt-3">
                <div class="row">
                    <h1>{{brandSlug}} Tyres</h1>
                </div>
        </div> -->

        <div class="container pt-3">
            <div class="row" v-if="pageDetails.block1_description">
                <!-- <h3>Brand Description</h3> -->
                <p style="width: 100%" class="ql-editor" v-html="pageDetails.block1_description"></p>
                <vue-editor style="display:none" />
            </div>
            <div class="row">
                <div class="col-md-4 col-lg-4 col-xl-3" v-if="pageDetails.block2_description">
                    <h3 class="text-center">About {{ tyreSizeSlug }}</h3>
                    <hr>
                    <p style="width: 100%" class="ql-editor" v-html="pageDetails.block2_description"></p>
                    <vue-editor style="display:none" />
                </div>
                <div v-if="tyre_size_width" :class="(pageDetails.block2_description) ? 'col-md-8 col-lg-8 col-xl-9' : 'col-md-12 col-lg-12 col-xl-12'">
                    <h3 class="text-center pb-2 mt-2" v-if="modelList.length">{{ $t('Most Popular Models') }}</h3>
                    <div class="row">
                        <div class="product-listing">
                            <div class="row">
                                <div v-for="model in modelList" :key="model.id" :class="(pageDetails.block2_description) ? 'col-md-12 col-lg-4 mb-2' : 'col-md-12 col-lg-3 mb-2'">
                                    <router-link :to="{ name: 'search-by-tyresize-height-width-diameter', params: { height_width_diameter: tyreSizeSlug} }">
                                        <b-card no-body class="p-1">
                                            <b-card-text class="text-center">
                                                {{ model.name }}
                                            </b-card-text>
                                        </b-card>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <br>
                        <div class="col-md-12 col-lg-12" v-if="totalModels != 0 && totalModels > modelPageSize">
                            <b-pagination 
                                pills 
                                v-model="currentModelPage" 
                                :total-rows="totalModels"
                                size="sm"
                                align="center"
                                class="mb-3 mt-2"
                                :per-page="modelPageSize"></b-pagination>
                        </div>
                        <br>
                    </div>
                    <hr v-if="tyreSizeTyreList.length">
                    <h3 class="text-center pb-2" v-if="tyreSizeTyreList.length">{{ $t('Most Popular Tyres') }}</h3>
                    <div class="row">
                        <!-- <div class="product-listing">
                            <div class="row">
                                <div v-for="tyre in tyreList" :key="tyre.id" class="col-md-12 col-lg-6">
                                    <b-link :to="{ name: 'product-details', params: {brand: tyre.brand.name, productName: normalizeString(tyre.name), productid: tyre.id } }">
                                        {{ tyre.name }}
                                    </b-link>
                                </div>
                            </div>
                        </div>
                        <br> -->
                        <div v-for="product in tyreSizeTyreList" :key="product.id" :class="(pageDetails.block2_description) ? 'col-md-12 col-lg-4' : 'col-md-12 col-lg-3'">
                            <single-product :product="product"></single-product>
                            <div :class="{ 'soldout' : product.in_stock <= 0 }" class="page product-item d-flex mb-4 offer">
                                <b-link :to="{ name: 'product-details', params: {brand: product.brand.name, productName: normalizeString(product.name), productid: product.id } }" class="product-image">
                                    <div 
                                        v-if="product.image" 
                                        class="plimg"
                                        :aria-label="product.name"
                                        :style="getImageURL(product)">
                                    </div>
                                    <div 
                                        v-else
                                        class="plimg" 
                                        :aria-label="product.name" 
                                        style="background-image:url('images/no-data-found.png');">
                                    </div>
                                    <div class="brandlogo" v-if="product.brand.image_path != null" v-bind:style="{ backgroundImage: 'url(' + product.brand.image_base_path+product.brand.image_path + ')' }" ></div>
                                    <div class="brandlogo-noimage" v-else style="background-image:url('images/nologo.png');"></div>
                                </b-link>
                                
                                <b-link :to="{ name: 'product-details', params: {brand: product.brand.name, productName: normalizeString(product.name), productid: product.id } }" class="product-info">
                                    <h3 class="mb-2">{{ product.name }}</h3>
                                    <!-- <ul class="eulabels pt-2 pb-2">
                                        <li><span class="eulabels-tag fuel-tag" :class="`level-`+product.fuel_effiency"><i class="fas fa-gas-pump"></i> {{product.fuel_effiency}}</span></li>  
                                        <li><span class="eulabels-tag wet-tag" :class="`level-`+product.wet_grip"><i class="fas fa-cloud-showers-heavy"></i> {{product.wet_grip}}</span></li>  
                                        <li>
                                            <span class="eulabels-tag noice-tag">
                                                <i class="fas">
                                                    <img v-if="product.noice_value < 69" src="../../public/images/volumeicon/vol1.png" />
                                                    <img v-else-if="product.noice_value >= 69 && product.noice_value < 73" src="../../public/images/volumeicon/vol2.png" />
                                                    <img v-else  src="../../public/images/volumeicon/vol3.png" />
                                                </i> 
                                                {{product.noice_value}}
                                            </span>
                                        </li>  
                                    </ul>
                                    <p class="pb-3 rc-block rc-label" v-if="product.is_recycled == '0'"><img class="rc-icon" src="../../public/images/recycling_icon.png" /><span class="rc-label-span">{{ $t('Recycling fee included') }}</span></p>
                                    <p v-if="product.available_quantity >= 4" class="text-success text-right font-weight-bold">{{ $t('In stock') }}</p>
                                    <p v-else class="text-danger text-right font-weight-bold">{{ $t('Available qty:') }} {{ product.available_quantity }}</p> -->
                                </b-link>
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-12" v-if="totalTyres != 0 && totalTyres > tyresPageSize">
                            <b-pagination 
                                pills 
                                v-model="currentTyrePage" 
                                :total-rows="totalTyres"
                                size="sm"
                                align="center"
                                class="mb-3 mt-2"
                                :per-page="tyresPageSize"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <hr v-if="pageDetails.block3_description">
            <div class="row" v-if="pageDetails.block3_description">
                <!-- <h3>Brand Description</h3> -->
                <p style="width: 100%" class="ql-editor" v-html="pageDetails.block3_description"></p>
                <vue-editor style="display:none" />
            </div>
        </div>
    </div>
</template>

<style scoped>
    .page .product-item { flex-direction:column;}
    .page .product-item .product-image, .product-item .product-info, .page .product-image { flex-basis: 100%; }
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import { VueEditor } from "vue2-editor"
import SearchTab from "../components/SearchTabs.vue";
import router from '../router';
import SingleProduct from "../components/SingleProduct.vue";
export default {
    name: "tyre_size",
    metaInfo() {
        return{
            title: this.tyreSizeSlug,
            meta: [
                { charset: 'utf-8' },
                { name: 'title', content: this.tyreSizeSlug},
                { name: 'description', content: this.pageDetails.meta_description},
                { name: 'keywords', content: 'renkaatalle, Renkaatalle.fi'},
                { name: 'robots', content: 'index,follow'}
            ]
        }
    },
    components: { VueEditor, "search-tabs": SearchTab, "single-product" : SingleProduct },
    data() {
      return {
        tyre_size: {name: ''},
        pageType: 'tyre_size',
        tyreSizeSlug: null,
        currentModelPage: 1,
        currentTyrePage: 1,
        modelPageSize: 36,
        totalModels: 0,
        modelTotalPage: 0,
        tyresPageSize: 12,
        totalTyres: 0,
        tyresTotalPage: 0,
        bannerLoading: true,
        tyre_size_width: '',
        tyre_size_height: '',
        tyre_size_diameter: ''
      }
    },
    async created() {
        document.body.classList.add('home');
        this.tyreSizeSlug = this.$route.params.height_width_diameter
        await this.getTyreSizeDetail(this.tyreSizeSlug)
        await this.getPageDetails()
        await this.getTyres()
    },
    watch: {
        '$route.query': {
            async handler(newValue, oldValue) {
                this.currentPage = 1;
            }
        },
        currentTyrePage (value) {
            this.getTyres()
            this.tyresTotalPage < value
        },
        currentModelPage (value) {
            this.modelTotalPage < value
        },
        "currentLang": {
            async handler(newValue) {
                await this.getPageDetails()
                await this.getTyres()
            }
        },
        "pageDetails": {
            handler(newValue) {
            }
        }
    },
    computed: {
        ...mapGetters('app', ['currentLang']),
        ...mapGetters('page', ['modelList', 'tyreList', 'tyreSizeTyreList','pageDetails']),
    },
    methods: {
        ...mapActions("page", ['fetchTyreSizeDetail', 'fetchModels', 'fetchTyres', 'fetchPageDetails', 'fetchTyreSizeTyres']),
        getPageDetails() {
            this.bannerLoading = true
            this.fetchPageDetails({type: this.pageType, type_name: this.tyreSizeSlug}).then(response => {

                if(!response.data.tyre_size_details){
                    var data = this.tyreSizeSlug.split("-");

                    this.tyre_size_width = data[0]
                    this.tyre_size_height = data[1].replace("R", "")
                    this.tyre_size_diameter = data[2]
                    /*router.push({name: 'page-not-found-redirect'});*/
                } else {
                    this.tyre_size_width = response.data.tyre_size_details.width;
                    this.tyre_size_height = response.data.tyre_size_details.height;
                    this.tyre_size_diameter = response.data.tyre_size_details.diameter;
                }
                
                this.bannerLoading = false
            })
            .catch(error => {
            }).finally(() => {
                this.loading = false;
            });
        },
        getTyreSizeDetail(slug) {
            this.bannerLoading = true
            this.fetchTyreSizeDetail(slug).then(response => {
                if (response.data) {
                    this.tyre_size = response.data
                }
                this.bannerLoading = false
            })
            .catch(error => {
            }).finally(() => {
                this.loading = false;
            });
        },
        getTyres() {

            let strDyn = "?per_page="+this.tyresPageSize+"&page="+this.currentTyrePage;

            this.fetchTyreSizeTyres({tyre_size: this.tyreSizeSlug, queryString: strDyn}).then(response => {
                this.totalTyres = response.data.total;
                this.tyresTotalPage= response.data.last_page;
            })
            .catch(error => {
            }).finally(() => {
                this.loading = false;
            });        
        },
        getImageURL(product) {
            return "backgroundImage: url('" + product.image.image_base_path+product.image.path + "')";
        },
        setCurrency(total) {
            let price = null
            if(total) {
                return total.replace(".", ",")+process.env.VUE_APP_CURRENCY_SIGN;
            } else {
                return price
            }
        }
    }
};

</script>
